const LineworkArt = ({ className = "", plain = false }) => (
  <svg
    viewBox="0 0 1600 900"
    preserveAspectRatio="xMidYMid slice"
    className={className}
    role="img"
    aria-label="Abstract architectural line drawing in the Stelcore brand style"
  >
    <rect width="1600" height="900" fill="#F7F6F2" />

    {/* faint taupe diagonal field, right side */}
    <g stroke="#8A7F73" strokeWidth="1" opacity="0.5" fill="none">
      <line x1="940" y1="0" x2="1600" y2="660" />
      <line x1="1060" y1="0" x2="1600" y2="540" />
      <line x1="1180" y1="0" x2="1600" y2="420" />
      <line x1="1300" y1="0" x2="1600" y2="300" />
      <line x1="1420" y1="0" x2="1600" y2="180" />
      <line x1="1600" y1="80" x2="1180" y2="500" />
      <line x1="1600" y1="200" x2="1280" y2="520" />
      <line x1="1600" y1="320" x2="1380" y2="540" />
    </g>

    {/* thin ink construction lines */}
    <g stroke="#111111" strokeWidth="1.5" fill="none">
      <line x1="0" y1="520" x2="1160" y2="520" />
      <line x1="0" y1="648" x2="1000" y2="648" />
      <line x1="240" y1="380" x2="240" y2="900" />
      <line x1="440" y1="520" x2="440" y2="900" />
      <line x1="700" y1="648" x2="700" y2="900" />
      <line x1="1160" y1="110" x2="1160" y2="520" />
      <line x1="1160" y1="110" x2="1600" y2="110" />
      <line x1="980" y1="520" x2="1500" y2="0" />
      <line x1="560" y1="900" x2="1240" y2="220" />
    </g>

    {/* cream separator above the bold diagonal */}
    {!plain && <line x1="0" y1="856" x2="1600" y2="392" stroke="#F7F6F2" strokeWidth="12" />}

    {/* bold black diagonal band */}
    {!plain && <polygon points="0,886 1600,418 1600,900 0,900" fill="#111111" />}

    {/* thin taupe line running inside the black band */}
    {!plain && <line x1="180" y1="900" x2="1600" y2="505" stroke="#8A7F73" strokeWidth="1.5" opacity="0.7" />}
  </svg>
);

export default LineworkArt;
